/* 🤖 this file was generated by script */
export const wsolidiconFaceSmile = {
  name: 'face_smile',
  data: `<svg viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M12 1a11 11 0 1 0 0 22 11 11 0 0 0 0-22M7.5 9a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m6 0a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m-6.1 4.2a1 1 0 0 1 1.4.2l.2.22q.21.24.65.57c.58.42 1.38.81 2.35.81s1.77-.39 2.35-.8a5 5 0 0 0 .85-.8 1 1 0 0 1 1.6 1.2l-.1.13a6 6 0 0 1-1.17 1.08c-.8.58-2 1.19-3.53 1.19a6 6 0 0 1-3.53-1.2 7 7 0 0 1-1.27-1.2 1 1 0 0 1 .2-1.4" clip-rule="evenodd"/></svg>`,
  iconStyle: 'solid',
};
